import { render } from "./PantryRecipeSearchView.vue?vue&type=template&id=4c18b72c&ts=true"
import script from "./PantryRecipeSearchView.vue?vue&type=script&lang=ts"
export * from "./PantryRecipeSearchView.vue?vue&type=script&lang=ts"

import "./PantryRecipeSearchView.vue?vue&type=style&index=0&id=4c18b72c&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__